// ANGULAR
import { Component, OnInit } from '@angular/core';

// OTHER
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

// ACTIUM
import { Infection } from 'src/app/models/infection';
import { InfectionDataService } from '../../../services/infection-service';

@Component({
    selector: 'app-delete-infection',
    templateUrl: './delete-infection.component.html',
    styleUrls: ['./delete-infection.component.scss']
})
export class DeleteInfectionComponent implements OnInit {

    public infection: Infection;

    constructor(private ref: DynamicDialogRef,
                private config: DynamicDialogConfig,
                private infectionService: InfectionDataService) { }

    ngOnInit(): void {
        this.infection = this.config.data.infection;
    }

    deleteInfection(): void {
        this.infectionService.deleteInfection(this.infection.id).subscribe((res: boolean) => {
            this.ref.close();
        });
    }
    cancelInfection(): void {
        this.ref.close();
    }
}
